import { useContext } from 'react';
import AlertContext from '../contexts/AlertContext';

const useAlertContext = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlertContext must be used within a AlertProvider');
  }
  return context;
};

export default useAlertContext;
